import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// import { SignUp } from '../components/signup';
import { ROUTES_CONSTANTS } from "../utils/constants/routesString";
import { Layout } from "../container/layout";


import SignUp from "../components/SignUp/SignUp";
import Onboarding from "../components/onboarding/";
import Bookings from "../components/Bookings/Bookings";
import ViewDetails from "../components/Bookings/ViewDetails";
import MyProfile from "../components/onboarding/MyProfile";
import PaymentMode from "../components/PaymentModes/PaymentMode";
import Terms from "../components/Policies/Terms";
import Privacy from "../components/Policies/Privacy";
import TransactionHistory from "../components/Bookings/TransactionHistory";
import SignIn from "../components/SignUp/SignIn";
import RescheduleCalender from "../components/onboarding/RescheduleCalender";
import Rescheduled from "../components/Emails/Rescheduled";
import Payment from "../components/SignUp/Payment";
import AgentVerifyOtp from "../components/BookingAgent/AgentVerifyOtp";
import AgentPayment from "../components/BookingAgent/AgentPayment";
import ShopifyAuthCallback from "../components/SignUp/ShopifyAuthCallback";

import Confirmed from "../components/Emails/Confirmed";
import NoPageFound from "../components/SignUp/NoPageFound";
import ProtectedRoute from "./ProtectedRoute";
import StylistThemeProvider from "../components/StylistThemeProvider";

// import NotFound from 'pages/notFound';
export default class AllRoutes extends Component {
  render() {
    return (
      <React.Fragment>
        <Router>
          <StylistThemeProvider>
            <Layout>
              <Routes>
              <Route
                path={`/:stylistcode/auth/callback`}
                element={<ShopifyAuthCallback />}
              />
              <Route
                path={`${ROUTES_CONSTANTS.index}/:stylistcode`}
                element={<Onboarding />}
              />
              <Route
                path={`/:stylistcode${ROUTES_CONSTANTS.agent_verify_otp}`}
                element={<AgentVerifyOtp />}
              />
              <Route
                path={`/:stylistcode${ROUTES_CONSTANTS.agent_payment}`}
                element={<AgentPayment />}
              />
              {/* <UnauthRouter exact path={ROUTES_CONSTANTS.signup} component={SignUp} />
                            <UnauthRouter exact path={ROUTES_CONSTANTS.signin} component={SignIn} />
                            <UnauthRouter exact path={ROUTES_CONSTANTS.forgotpwd} component={ForgotPassword} />
                            <UnauthRouter exact path={`${ROUTES_CONSTANTS.resetpwd}/:uid/:token`} component={ResetPassword} /> */}

              {/* <PrivateRoute
                exact
                path={ROUTES_CONSTANTS.my_profile}
                element={<MyProfile />}
              /> */}
              <Route element={<ProtectedRoute />}>
                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.my_profile}`}
                  element={<MyProfile />}
                />
                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.payment_modes}`}
                  element={<PaymentMode />}
                />

                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.bookings}`}
                  element={<Bookings />}
                />
                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.reschedule}`}
                  element={<RescheduleCalender />}
                />
                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.rebook}`}
                  element={<RescheduleCalender />}
                />
                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.rescheduleSucess}`}
                  element={<Rescheduled />}
                />
                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.confirmed}`}
                  element={<Confirmed />}
                />

                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.rebookpayment}`}
                  element={<Payment />}
                />

                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.booking_details}`}
                  element={<ViewDetails />}
                />

                <Route
                  path={`/:stylistcode${ROUTES_CONSTANTS.transaction_history}`}
                  element={<TransactionHistory />}
                />
              </Route>

              <Route
                path={`/:stylistcode${ROUTES_CONSTANTS.signin}`}
                element={<SignIn />}
              />
              <Route
                path={`/:stylistcode${ROUTES_CONSTANTS.terms}`}
                element={<Terms />}
              />

              <Route
                path={`/:stylistcode${ROUTES_CONSTANTS.privacy}`}
                element={<Privacy />}
              />

              <Route
                path={ROUTES_CONSTANTS.no_route}
                element={<NoPageFound />}
              />

              <Route
                path={`/:stylistcode${ROUTES_CONSTANTS.signup}`}
                element={<SignUp />}
              />

              {/* <Route
                path={ROUTES_CONSTANTS.dashboard}
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              /> */}

              {/* <PrivateRoute path={ROUTES_CONSTANTS.dashboard} element={<Dashboard />} /> */}
              {/* <Route path={ROUTES_CONSTANTS.test} element={<Test />} /> */}
              {/* <Route path={ROUTES_CONSTANTS.signin} element={<SignIn />} /> */}

              {/* <PrivateRoute exact path={'/settings/:id'} component={Settings} /> */}
              {/* <PrivateRoute exact path={'/*'} component={NotFound} />  */}
              </Routes>
            </Layout>
          </StylistThemeProvider>
        </Router>
      </React.Fragment>
    );
  }
}